import styled from 'styled-components';
import { ProductNameTextProps } from '..';

export const ProductContainer = styled.div`
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: auto;
  & a {
    text-decoration: none;
  }
`;

export const ProductData = styled.div`
  text-align: left;
  & img:first-child {
    text-align: center;
  }
`;

export const ProductImageStyled = styled.img`
  width: 137px;
`;

export const BrandText = styled.p`
  font-size: 14px;
  font-family: Lato, sans-serif;
  margin-top: 4px;
  margin-bottom: 4px;
  color: #595959;
`;

export const ProductNameText = styled.p<ProductNameTextProps>`
  font-size: 17px;
  font-weight: normal;
  font-family: Lato, sans-serif;
  margin-top: 4px;
  margin-bottom: 6px;
  color: #333333;
  height: ${({ height = 'auto' }) => height};
`;

export const RatingContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin-bottom: 6px;
`;

export const ReviewValue = styled.p`
  font-size: 17px;
  font-weight: normal;
  font-family: Lato, sans-serif;
  margin-top: 0;
  margin-bottom: 0;
  padding-left: 7px;
  color: #333333;
`;

export const ImageContainer = styled.div`
  width: 100%;
  height: 137px;
  align-items: center;
  position: relative;
  justify-content: center;
  display: flex;
  overflow: hidden;
`;

export const SelectedProductBadge = styled.div`
  font-weight: 400;
  background: #0072ce;
  border-radius: 3px;
  font-size: 12px;
  padding: 2px 4px;
  color: #ffffff;
  position: absolute;
  bottom: 0;
  left: 0;
  line-height: 16px;
`;
